import moment from "moment";

export const getRangeForPreset = (preset: string): [Date, Date] => {
    const now = moment();

    switch (preset) {
        case 'Today': {
            const start = now.clone().startOf('day');
            const end = now.clone().endOf('day');
            return [start.toDate(), end.toDate()];
        }
        case 'This week': {
            const today = now.toDate();
            const currentDay = today.getDay(); // 0 (Sun) to 6 (Sat)

            // Find next or current Saturday
            const daysUntilSaturday = 6 - currentDay;
            const endDate = moment(today).add(daysUntilSaturday, 'days').endOf('day');

            // Find start date (7 days before end date)
            const startDate = endDate.clone().subtract(7, 'days').startOf('day');

            return [startDate.toDate(), endDate.toDate()];
        }
        case 'This month': {
            const start = now.clone().startOf('month');
            const end = now.clone().endOf('month');
            return [start.toDate(), end.toDate()];
        }
        case 'Next week': {
            const start = now.clone().add(1, 'week').startOf('week');
            const end = now.clone().add(1, 'week').endOf('week');
            return [start.toDate(), end.toDate()];
        }
        case 'Next month': {
            const start = now.clone().add(1, 'month').startOf('month');
            const end = now.clone().add(1, 'month').endOf('month');
            return [start.toDate(), end.toDate()];
        }
        default: {
            const start = now.clone().startOf('day');
            const end = now.clone().endOf('day');
            return [start.toDate(), end.toDate()];
        }
    }
};